import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { Grupo, Miembro } from '../../../common/grupo';
import * as _ from 'lodash';

@Component({
    selector: 'grupo-tag',
    template: require('./grupo.component.html')
})
export class GrupoComponent implements OnInit {
    
    @Input() edicion: boolean;     // undefined => nuevo, true 
    @Input() grupo: Grupo;
    @Output('grupo') _grupo = new EventEmitter<{ grupo: Grupo, update: boolean }>();
    @Output() editar = new EventEmitter<number>();
    
    constructor() { }

    ngOnInit() { }
    
    removerMiembro(usuario: string) {
        let miembros: Miembro[] = <Miembro[]>this.grupo.miembros;
        let index = _.findIndex(miembros, ['exten', usuario]);
        miembros.splice(index, 1);
    }
    
    guardar(grupo: Grupo) {
        this._grupo.emit({
            grupo: grupo, 
            update: this.edicion === undefined ? false: true
        });
    }
    
    eliminarGrupo(grupo: Grupo) {
        this._grupo.emit({
            grupo: grupo, 
            update: undefined
        });
    }
    
    seleccion(idgrupo: number) {
        this.editar.emit(idgrupo);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/angular2-router-loader/src!./app/admin/grupos/grupo.component.ts